import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

export const SpaceSlicer = createSlice({
  name: 'Space',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISlotList[]>,
  reducers: {
    getSpace: (state, _) => {
      state.isLoading = true;
    },
    successGetSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearSpaceState: (state) => {
      state.data = {};
    },
  },
});

export const { getSpace, failureGetSpace, successGetSpace, clearSpaceState } =
  SpaceSlicer.actions;

export default SpaceSlicer.reducer;
